export default "Moteurs IE3 / IE4 haute efficacité — Fiche CEE IND-UT-102 | Solution Éco France";
